import type { SupportChatResources } from './types';

export const sk: SupportChatResources = {
	'widget.launcherLabel': 'Otvoriť asistenta',
	'widget.title': 'AssistON',
	'widget.close': 'Zavrieť',
	'widget.back': 'Späť',
	'widget.restart': 'Začať odznova',
	'widget.send': 'Odoslať',
	'widget.typing': 'Asistent píše…',
	'widget.retry': 'Skúsiť znova',
	'widget.skip': 'Preskočiť',
	'widget.privacy': 'Údaje len na vybavenie požiadavky.',
	'widget.privacyLink': 'Ochrana údajov',
	'widget.online': 'Online · odpovedám okamžite',

	'launcher.title': 'Potrebujete pomoc?',
	'launcher.subtitle': 'Vstupenky, platby, faktúry',
	'launcher.resume': 'Pokračovať v rozhovore',
	'launcher.resumeSubtitle': 'Máte rozpracovanú požiadavku',

	'teaser.title': 'Ahoj 👋 Som AssistON',
	'teaser.body': 'Neprišla vám vstupenka alebo máte otázku k objednávke? Vyriešime to za pár sekúnd.',
	'teaser.bodyEvent': 'Máte otázku k eventu {eventName}? Vstupenky, platby aj faktúry vyriešime priamo tu.',
	'teaser.dismiss': 'Zavrieť',

	'hero.title': 'Ahoj! 👋',
	'hero.text': 'Som AssistON. S čím vám môžem pomôcť?',

	'common.yes': 'Áno',
	'common.no': 'Nie',
	'common.dontKnow': 'Neviem',
	'common.confirm': 'Odoslať požiadavku',
	'common.skipped': '(preskočené)',
	'common.phoneLine': 'Telefón: {phone}',
	'common.gladToHelp': 'Super, som rád, že to pomohlo. Ak by ste ešte niečo potrebovali, som tu. 👋',
	'common.didItHelp': 'Pomohlo vám to?',
	'common.askOrderEmail': 'Aký e-mail ste použili pri objednávke?',
	'common.describePlaceholder': 'Napíšte pár viet…',

	'main.greeting': 'Ahoj 👋 Som AssistON. S čím vám môžem pomôcť?',
	'main.again': 'Je ešte niečo, s čím vám môžem pomôcť?',
	'end.anotherQuestion': 'Mám ďalšiu otázku',
	'end.done': 'Hotovo, ďakujem',
	'review.text': 'Ak ste boli s riešením spokojní, budem rád, ak nám zanecháte hodnotenie. Pomôže to aj ďalším zákazníkom.',
	'review.button': 'Ohodnotiť Inviton na Google',

	'flow.ticketNotReceived': 'Neprišla / chýba mi vstupenka',
	'flow.paymentProblem': 'Problém s platbou',
	'flow.invoiceChange': 'Potrebujem upraviť faktúru',
	'flow.changeData': 'Potrebujem zmeniť údaje',
	'flow.eventQuestion': 'Otázka k eventu',
	'flow.promoCode': 'Zľavový kód alebo voucher',
	'flow.refund': 'Storno / vrátenie peňazí',
	'flow.organizer': 'Som organizátor',
	'flow.other': 'Iné / vlastná otázka',

	'human.option': 'Potrebujem hovoriť s človekom',
	'human.intro': 'Rozumiem. Živý chat s operátorom zatiaľ nemáme, ale naša podpora vám rada odpovie e-mailom.',
	'human.email': 'Napíšte mi svoju otázku rovno sem. Odovzdám ju podpore aj so všetkými detailmi a odpovie vám e-mailom.',
	'human.writeInstead': 'Napísať otázku tu',
	'human.backToMenu': 'Späť na hlavné menu',

	'event.confirmQuestion': 'Ide o event {eventName}?',
	'event.confirmYes': 'Áno, {eventName}',
	'event.other': 'Iný event',
	'event.askName': 'Na aký event ste vstupenku kupovali?',
	'event.askNamePromo': 'Na aký event chcete kód alebo voucher uplatniť?',
	'event.askNameNeutral': 'O aký event ide?',
	'event.namePlaceholder': 'Názov eventu',
	'event.namePlaceholderOptional': 'Názov eventu (nepovinné)',
	'event.askNameOptional': 'O aký event ide? Ak sa vaša otázka netýka konkrétneho eventu, nechajte pole prázdne a pošlite.',
	'event.unconfirmed': 'Rozumiem. Event radšej nechám dohľadať podporu.',
	'event.askNameAgain': 'Napíšte mi, prosím, presný názov eventu, ako je uvedený na vstupenke alebo na webe.',
	'event.confirmMatchNo': 'Nie, iný event',
	'event.confirmMatchYes': 'Áno, to je on',
	'event.confirmMatchNoDate': 'Našiel som event {matchedEventName}. Je to ten správny?',
	'event.confirmMatch': 'Našiel som event {matchedEventName} ({matchedEventDate}). Je to ten správny?',


	'date.today': 'Dnes',
	'date.yesterday': 'Včera',
	'date.last7': 'Posledných 7 dní',
	'date.older': 'Viac ako týždeň',

	'contact.useOrderEmail': 'Máme vám odpovedať na {orderEmail}?',
	'contact.yesSame': 'Áno, na túto adresu',
	'contact.useOther': 'Použiť inú adresu',
	'contact.askEmail': 'Na aký e-mail vám má podpora odpovedať?',

	'escalation.confirmIntro': 'Ďakujem. Toto pošlem našej podpore, skontrolujte si, prosím, či všetko sedí:',
	'escalation.sending': 'Odosielam požiadavku podpore…',
	'escalation.done': 'Hotovo ✅ Požiadavku som odovzdal podpore.',
	'escalation.confirmationMail': 'Podpora vám odpovie na {contactEmail}. Odpovedáme v pracovné dni, zvyčajne v priebehu pár hodín; požiadavky z večera a víkendu vybavíme nasledujúci pracovný deň. Požiadavku nie je potrebné posielať znova.',
	'escalation.doneFollowUp': 'Hotovo ✅ Vašu skoršiu požiadavku už podpora má, túto som k nej pripojil.',
	'escalation.failed': 'Ospravedlňujem sa, požiadavku sa teraz nepodarilo odoslať. Napíšte nám, prosím, priamo na {supportEmail}.',

	'error.actionFailed': 'Niečo sa pokazilo. Skúste to, prosím, ešte raz.',
	'error.rateLimited': 'Príliš veľa pokusov. Skúste to, prosím, o chvíľu.',

	'validation.email': 'Zadajte, prosím, platnú e-mailovú adresu.',
	'validation.required': 'Toto pole je povinné.',
	'validation.tooLong': 'Text je príliš dlhý.',
	'validation.moreDetails': 'Napíšte mi, prosím, viac podrobností, aby podpora vedela, o čo ide.',

	// 1. ticket not received
	'tnr.intro': 'To vyriešime. Objednávku vám vyhľadám a vstupenku pošlem znova.',
	'tnr.introFromPayment': 'Rozumiem. Skontrolujem stav vašej objednávky.',
	'tnr.moneyQuestion': 'Odišli vám peniaze z účtu?',
	'tnr.askOrderEmail': 'Aký e-mail ste zadali pri objednávke? Podľa neho objednávku vyhľadám.',
	'tnr.lookingUp': 'Hľadám vašu objednávku…',
	'field.emailCode': 'Overovací kód',
	'code.sendFailed': 'Overovací kód sa mi teraz nepodarilo poslať. Skúste to, prosím, o chvíľu znova.',
	'code.expired': 'Kód už neplatí, posielam vám nový.',
	'code.invalid': 'Kód nesedí. Skúste ho, prosím, opísať ešte raz.',
	'code.checking': 'Overujem kód…',
	'code.placeholder': '6-miestny kód',
	'code.enter': 'Kód som vám poslal na {orderEmail}. Zadajte ho, prosím, sem. Ak vám neprišiel, pozrite si aj priečinok SPAM.',
	'code.sending': 'Na tento e-mail vám posielam overovací kód…',
	'tnr.lookingUpAgain': 'Skúšam to ešte raz s ďalšími údajmi…',
	'tnr.paidFound': 'Našiel som vašu zaplatenú objednávku na tento event. Vstupenky vám môžem poslať znova na {orderEmail}.',
	'tnr.resendButton': 'Poslať vstupenku znova',
	'tnr.contactSupportInstead': 'Radšej kontaktovať podporu',
	'tnr.supportQuestion': 'Napíšte mi, prosím, čo potrebujete s podporou vyriešiť.',
	'tnr.resending': 'Posielam vstupenku…',
	'tnr.resendDone': 'Vstupenky som vám preposlal ešte raz. Skontrolujte si prípadne aj priečinky SPAM alebo Reklama.',
	'tnr.helped': 'Prišla vám vstupenka?',
	'tnr.resolved': 'Super 🎉 Prajem príjemný zážitok na evente!',
	'tnr.notHelped': 'Rozumiem. Odovzdám to teda podpore aj so všetkým, čo sme zistili.',
	'tnr.resendFailed': 'Vstupenku sa mi teraz nepodarilo odoslať. Odovzdám to podpore, aby sa na to pozrela.',
	'tnr.notPaidRepeat': 'Ak vám peniaze neodišli, platba neprebehla a objednávka sa automaticky zrušila. Vytvorte si ju, prosím, znova.',
	'tnr.eventEnded': 'Tento event už skončil, vstupenky k nemu už neposielame. Ak potrebujete niečo iné, rád pomôžem ďalej.',
	'tnr.pendingTransfer': 'Objednávku som našiel, čaká sa na platbu prevodom. Prevod môže trvať 2 až 3 dni. Keď sa nám peniaze pripíšu, objednávka sa automaticky potvrdí a vstupenky vám pošleme e-mailom.',
	'tnr.notPaidProof': 'Pošlite nám, prosím, potvrdenie o platbe na {supportEmail}. Stačí detail platby z výpisu z účtu alebo z bankovej aplikácie, screenshot autorizácie nestačí. Do predmetu uveďte e-mail z objednávky a názov eventu. Platbu ručne preveríme a vstupenky vám pošleme.',
	'tnr.notPaidFound': 'Objednávku som našiel, ale platba k nám zatiaľ nedorazila.',
	'tnr.notFound': 'Podľa tohto e-mailu som objednávku nenašiel, možno bol v adrese preklep. Skúsime to podľa eventu.',
	'tnr.multipleOrders': 'Pod týmto e-mailom vidím viac zaplatených objednávok. Napíšte mi, prosím, o ktorý event ide.',
	'tnr.askPurchaseDate': 'Približne kedy ste vstupenku kupovali?',
	'tnr.stillNotFound': 'Objednávku sa mi nepodarilo nájsť ani takto. Odovzdám to podpore, ktorá to preverí ručne.',

	// 2. payment
	'pay.whatHappened': 'Čo presne sa stalo?',
	'pay.chargedTwice': 'Zaplatil som dvakrát',
	'pay.paymentFailed': 'Platba zlyhala',
	'pay.bankTransfer': 'Platím prevodom',
	'pay.other': 'Niečo iné',
	'pay.failedInfo': 'Objednávka sa pri neúspešnej platbe automaticky zruší a nedá sa dodatočne uhradiť. Vytvorte si, prosím, novú.',
	'pay.failedTryAgain': 'Podarilo sa vám objednávku dokončiť?',
	'pay.stillFailing': 'Nie, stále to zlyháva',
	'pay.describe': 'Opíšte mi, prosím, čo sa stalo (suma, dátum, spôsob platby).',
	'pay.refundPendingInfo2': 'Ak vrátenú platbu na účte nevidíte, skontrolujte aj pôvodnú platbu. Pôvodná transakcia býva niekedy stornovaná, takže vrátenie sa nezobrazí ako samostatná príjmová položka. Pôvodná platba sa potom nemusí zobraziť vôbec alebo je pri nej uvedené „zrušená“.',
	'pay.refundPendingInfo1': 'Vrátenie platby môže trvať 2 až 3 pracovné dni, kým sa suma zobrazí späť na vašom účte.',
	'pay.refundStillMissing': 'Stále ju nevidím',
	'pay.refundHelped': 'Pomohlo vám to?',
	'pay.refundPending': 'Čakám na vrátenie peňazí',

	// 3. invoice
	'inv.haveOrder': 'Máte už vytvorenú objednávku?',
	'inv.haveOrderYes': 'Áno, už mám objednávku',
	'inv.haveOrderNo': 'Ešte nie, chcem kúpiť na faktúru',
	'inv.howToBuy': 'V poslednom kroku nákupu zaškrtnite „Prajete si vystaviť faktúru“ a vyplňte fakturačné údaje.',
	'inv.howToBuyTransfer': 'Ako spôsob platby zvoľte „Bankový prevod“. Údaje na úhradu vám prídu e-mailom spolu so zálohovou faktúrou.',
	'inv.disabled': 'Organizátor má pri tomto podujatí vystavovanie faktúr vypnuté. Inviton je iba predajca vstupeniek, faktúru vám vystaví organizátor. Vstupenka slúži ako cenina.',
	'inv.disabledContact': 'Kontaktujte ho, prosím, priamo na {organizerEmail}.',
	'inv.disabledNoContact': 'Kontakt na organizátora som pri evente {eventName} nenašiel. Odovzdám to podpore, tá kontakt dohľadá a ozve sa vám.',
	'inv.askNewData': 'Aké fakturačné údaje majú byť na faktúre?',
	'inv.askWhatToFix': 'Čo presne treba na faktúre opraviť?',
	'inv.eventNotFound': 'Event som podľa názvu nenašiel. Odovzdám to podpore aj s vaším opisom.',
	'inv.company': 'Meno / názov firmy',
	'inv.ico': 'IČO',
	'inv.dic': 'DIČ',
	'inv.icdph': 'IČ DPH',
	'inv.street': 'Ulica a číslo',
	'inv.city': 'Mesto',
	'inv.zip': 'PSČ',
	'inv.country': 'Krajina',

	// 4. change data
	'chg.what': 'Čo potrebujete zmeniť?',
	'chg.holderName': 'Meno na vstupenke',
	'chg.email': 'E-mail na objednávke',
	'chg.eventDate': 'Termín / dátum vstupenky',
	'chg.other': 'Niečo iné',
	'chg.holderSelfService': 'Meno na vstupenke je len interná informácia, aby sme ju vedeli dohľadať. Na vstupe s tým problém nebude, môže ju použiť aj niekto iný.',
	'chg.dateIsOrganizer': 'Zmenu termínu schvaľuje organizátor eventu. Pripravím požiadavku, ktorú podpora s organizátorom overí.',
	'chg.describe': 'Napíšte mi, prosím, čo presne treba zmeniť (pôvodný údaj → nový údaj).',
	'chg.describeHolder': 'Aké meno je na vstupenke teraz a aké má byť?',
	'chg.describeEmail': 'Aký nový e-mail má byť na objednávke?',

	// 5. refund
	'evq.intro': 'Na otázky k samotnému podujatiu odpovie najlepšie jeho organizátor – nájdem vám naň kontakt.',
	'evq.organizerEmail': 'Obráťte sa, prosím, priamo na organizátora na {organizerEmail}, poskytne vám presné informácie.',
	'evq.organizerUnknown': 'Kontakt na organizátora som pri evente {eventName} nenašiel. Odovzdám to podpore, tá kontakt dohľadá a ozve sa vám.',
	'promo.intro': 'Zľavové kódy a vouchery nastavuje organizátor, ale pozriem sa na to s podporou.',
	'promo.describe': 'Napíšte, prosím, aký kód alebo voucher zadávate a čo sa stane, keď ho použijete (napríklad text chybovej hlášky).',
	'promo.stillNotWorking': 'Ak vám kód nefunguje ani potom, odovzdám ho podpore, tá preverí jeho využitie v systéme.',
	'promo.blocked': 'Kód, ktorý ste použili pri nedokončenej objednávke, je blokovaný 15 minút, kým sa čaká na platbu. Potom sa automaticky odblokuje.',
	'promo.twoCodes2': 'Zľavový kód je možné použiť len jeden na objednávku, bez ohľadu na počet lístkov v objednávke.',
	'promo.twoCodes1': 'Ak chcete uplatniť dva zľavové kódy na jedno predstavenie, je potrebné spraviť dve samostatné objednávky.',
	'ref.intro': 'O vrátení vstupeniek rozhoduje organizátor podujatia. Inviton je predajca vstupeniek a nemá oprávnenie o stornovaní ani o vrátení peňazí rozhodovať.',
	'ref.findingOrganizer': 'Hľadám kontakt na organizátora…',
	'ref.organizerEmail': 'Napíšte mu, prosím, priamo na {organizerEmail}{organizerPhoneLine}\n\nPodmienky storna bývajú v popise podujatia: {eventUrl}\n\nAk so stornom a vrátením peňazí bude súhlasiť, refundáciu následne spracujeme my.',
	'ref.organizerUnknown': 'Kontakt na organizátora som pri evente {eventName} nenašiel. Odovzdám to podpore, tá kontakt dohľadá a ozve sa vám.',

	// 6. organizer
	'org.contactPhoneAndEmail': 'Organizátorom pomáhame priamo. Zavolajte nám na {supportPhone} alebo napíšte na {supportEmail}.',
	'org.describe': 'Opíšte mi, prosím, čo presne potrebujete. Čím viac detailov, tým rýchlejšie vám vieme pomôcť.',
	'org.topicOther': 'Niečo iné',
	'org.topicHowTo': 'Návod: admin, publikovanie, vyúčtovanie',
	'org.howToWhich': 'Čo potrebujete?',
	'org.howToAdmin': 'Pridať ďalšieho admina k eventu',
	'org.howToUnpublished': 'Predaj na nepublikovaný event',
	'org.howToPublish': 'Ako požiadať o publikovanie',
	'org.howToPayout': 'Kedy príde vyúčtovanie a peniaze',
	'org.kbAdmin': 'Ďalšieho administrátora pridáte v administrácii podujatia: Upraviť event → Všeobecné nastavenia → Pokročilé → Administrátori.',
	'org.kbUnpublished': 'Áno, vstupenky je možné predávať aj na nepublikovaný event. Stačí zákazníkovi zaslať priamy odkaz na podujatie, prostredníctvom ktorého si môže vstupenky zakúpiť.',
	'org.kbPublish': 'V administrácii podujatia prejdite do sekcie Upraviť event → Všeobecné nastavenia. Vedľa tlačidla Uložiť kliknite na tlačidlo Možnosti a vyberte Zverejniť event.',
	'org.kbPayout1': 'Vyúčtovanie prebieha v týchto krokoch:\n1. Prvý pondelok po skončení podujatia vám zašleme vyúčtovací protokol.\n2. Nasledujúcich 7 dní máte na kontrolu vyúčtovania a zaslanie prípadných pripomienok. Na základe nich vyúčtovanie upravíme.',
	'org.kbPayout2': '3. Nasledujúci pondelok vám automaticky odošleme peniaze, pokiaľ ste k vyúčtovaniu nemali pripomienky alebo boli vaše pripomienky vyriešené.',
	'org.topicServices': 'Informácie o službách',
	'org.topicSetup': 'Pomoc s nastavením',
	'org.topicProblem': 'Problém s eventom',
	'org.topicQuote': 'Cenová ponuka',
	'org.orWriteHere': 'Alebo mi napíšte rovno sem, čo potrebujete, a odovzdám to kolegom. O čo ide?',

	// 7. other
	'oth.askQuestion': 'Napíšte mi svoju otázku. Odovzdám ju podpore presne tak, ako ju napíšete.',
	'oth.placeholder': 'Vaša otázka…',

	// summary field labels
	'field.topic': 'Téma',
	'field.situation': 'Situácia',
	'sit.tnr.notFound': 'Objednávka nenájdená ani podľa eventu a dátumu nákupu',
	'sit.tnr.resendNotHelped': 'Zaplatená objednávka nájdená, vstupenka bola preposlaná, ale neprišla',
	'sit.tnr.resendFailed': 'Zaplatená objednávka nájdená, automatické preposlanie vstupenky zlyhalo',
	'sit.tnr.supportInstead': 'Zaplatená objednávka nájdená, zákazník chce riešiť s podporou',
	'sit.chg.date': 'Zmena termínu vstupenky (schvaľuje organizátor)',
	'sit.promo.blocked': 'Kód nefunguje ani po 15 minútach od nedokončenej objednávky, treba preveriť využitie v systéme',
	'sit.noOrganizerContact': 'Pri evente sa nenašiel kontakt na organizátora, zákazník potrebuje sprostredkovať',
	'sit.pay.refundMissing': 'Zákazník nevidí vrátenú platbu ani po 2–3 pracovných dňoch',
	'sit.inv.eventNotFound': 'Event sa podľa názvu nenašiel, opravu faktúry rieši podpora',
	'sit.eventUnconfirmed': 'Event sa podľa názvu nepodarilo jednoznačne určiť, zákazník navrhnutý event odmietol',
	'field.eventName': 'Event',
	'field.orderEmail': 'E-mail objednávky',
	'field.contactEmail': 'E-mail na odpoveď',
	'field.moneyLeft': 'Peniaze odišli',
	'field.purchaseRange': 'Dátum nákupu',
	'field.description': 'Popis',
	'field.paymentIssue': 'Typ problému',
	'field.changeKind': 'Zmena',
	'field.invoiceData': 'Fakturačné údaje',
	'field.organizerTopic': 'Typ požiadavky',
	// --- odpovede, ktoré asistent dáva sám (analýza 2026-10-14)
	'common.notEnough': 'Nie, chcem napísať podpore',
	'common.notHelpedDescribe': 'Rozumiem, odovzdám to kolegom z podpory. Napíšte mi prosím, čo potrebujete.',
	'flow.availability': 'Chcem vstupenku / je ešte voľné?',
	'flow.orderStatus': 'Skontrolovať objednávku a platbu',
	'pay.checkStatus': 'Neviem, či mi prešla platba',

	'avl.intro': 'Pozriem sa do systému, či sa vstupenky dajú ešte kúpiť.',
	'avl.checking': 'Kontrolujem dostupnosť…',
	'avl.onSale': 'Vstupenky na {eventName} sa stále dajú kúpiť online tu: {eventUrl}',
	'avl.onSaleWithDate': 'Vstupenky na {eventName} sa stále dajú kúpiť online, najbližší termín je {nextDate}. Kúpite ich tu: {eventUrl}',
	'avl.onSaleSeating': 'Predaj vstupeniek na {eventName} je otvorený. Konkrétne miesto si vyberiete priamo v mape sedenia na stránke podujatia: {eventUrl}',
	'avl.soldOut': 'Na {eventName} už nie sú dostupné žiadne vstupenky – termín je vypredaný.',
	'avl.soldOutOtherDate': 'Na najbližší termín podujatia {eventName} sú vstupenky vypredané. Voľné sú ešte na termín {otherDate}, kúpite ich tu: {eventUrl}',
	'avl.saleEnded': 'Predaj vstupeniek na {eventName} už bol ukončený, kúpiť sa už nedajú.',
	'avl.saleNotStarted': 'Predaj vstupeniek na {eventName} sa otvorí {saleStart}. Potom ich nájdete tu: {eventUrl}',
	'avl.noOnlineSale': 'Organizátor podujatia {eventName} momentálne nemá vstupenky v online predaji u nás. Ak máte záujem, najlepšie je obrátiť sa priamo na neho.',
	'avl.eventEnded': 'Podujatie {eventName} už prebehlo, vstupenky sa naň už kúpiť nedajú.',
	'avl.notFound': 'Toto podujatie som v systéme nenašiel, tak to nechcem tvrdiť naslepo.',
	'avl.notFoundDescribe': 'Napíšte mi prosím, o aké podujatie a termín ide – odovzdám to kolegom a ozvú sa vám.',

	'ost.intro': 'Pozriem sa, čo k vašej e-mailovej adrese vidíme v systéme. Najprv vám na ňu pošlem overovací kód.',
	'ost.checking': 'Kontrolujem objednávky a platby…',
	'ost.paid': 'Na adresu {orderEmail} vidím v systéme dokončenú a zaplatenú objednávku. Platba teda prešla a vstupenky boli odoslané na túto adresu.',
	'ost.paidAndFailed': 'Na adresu {orderEmail} vidím v systéme dokončenú objednávku, ale aj neúspešné pokusy o platbu. Za neúspešné pokusy by vám peniaze strhnuté byť nemali.',
	'ost.resendOffer': 'Chcete, aby som vám vstupenky poslal na {orderEmail} znova?',
	'ost.resendButton': 'Áno, pošli vstupenky znova',
	'ost.allGood': 'Nie, to je všetko',
	'ost.failedOnly': 'Na adresu {orderEmail} vidím v systéme len neúspešné pokusy o platbu a žiadnu dokončenú objednávku. Vstupenky teda zakúpené nemáte a peniaze by vám strhnuté byť nemali.',
	'ost.failedAdvice': 'Pri ďalšom pokuse pomáha zaplatiť kartou priamo (nie cez Google Pay alebo Apple Pay) a otvoriť stránku v bežnom prehliadači, nie v aplikácii Instagramu či Facebooku – overenie 3D Secure v nich často neprejde.',
	'ost.willTryAgain': 'Dobre, skúsim nákup znova',
	'ost.moneyLeftAnyway': 'Peniaze mi aj tak odišli z účtu',
	'ost.moneyLeftDescribe': 'Napíšte mi prosím sumu a dátum platby – kolegovia platbu dohľadajú v platobnej bráne a ozvú sa vám.',
	'ost.pendingTransfer': 'V systéme vidím objednávku, ktorá čaká na bankový prevod. Pripísanie prevodu môže trvať niekoľko pracovných dní. Po pripísaní platby sa objednávka potvrdí automaticky a vstupenka vám príde e-mailom, netreba nič ďalšie robiť.',
	'ost.nothingFound': 'Na adresu {orderEmail} nevidím v systéme žiadnu objednávku ani pokus o platbu. Nemohli ste pri nákupe použiť inú e-mailovú adresu?',
	'ost.tryOtherEmail': 'Skúsim inú adresu',
	'ost.manualCheck': 'Na adresu {orderEmail} vidím platbu, ktorú ešte musí skontrolovať kolega v platobnej bráne. Prosím, neplaťte zatiaľ znova – odovzdám to podpore a ozve sa vám.',
	'ost.severalEvents': 'Na adresu {orderEmail} vidím zaplatené objednávky na viac podujatí. Aby som pracoval so správnou, potrebujem vedieť, o ktoré podujatie ide.',
	'ost.severalEventsUnresolved': 'Podujatie sa mi nepodarilo jednoznačne priradiť. Odovzdám to kolegom, ktorí objednávku dohľadajú.',
	'ost.somethingWrong': 'Niečo mi nesedí',
	'ost.paidIssueDescribe': 'Napíšte mi prosím, čo nesedí (napríklad peniaze strhnuté dvakrát alebo iná suma) – kolegovia to preveria a ozvú sa vám.',

	'kb.promoWhere': 'Zľavový kód sa zadáva v poslednom kroku nákupu, pri checkoute. Na jeden kód platí zľava na jednu vstupenku a po použití ho už znova použiť nejde.',
	'kb.walletPayment': 'Platby cez Google Pay a Apple Pay nám platobná brána pomerne často zamietne, najmä keď je stránka otvorená v aplikácii Instagramu, Facebooku alebo Gmailu.',
	'kb.walletPaymentSteps': 'Skúste prosím zaplatiť kartou priamo (zadať údaje karty) a stránku otvoriť v bežnom prehliadači, napríklad v Chrome alebo Safari. Overenie 3D Secure tam prejde bez problémov.',
	'kb.changePayment': 'Spôsob platby na už vytvorenej objednávke zmeniť nejde. Neuhradená objednávka sa po chvíli automaticky zruší – stačí vytvoriť novú a zvoliť v nej požadovaný spôsob platby.',
	'kb.bankTransfer': 'Spôsob platby sa volí v poslednom kroku objednávky: najprv vyberiete druh vstupenky a zadáte e-mail, potom sa zobrazia možnosti platby. Ponúkame len tie, ktoré organizátor pri podujatí povolil – ak tam bankový prevod nie je, pri tomto podujatí ho organizátor nepovolil.',
	'kb.blueSeats': 'Miesta označené modrou farbou sú dočasne rezervované, kým systém čaká na úhradu. Ak platba neprebehne, automaticky sa uvoľnia a dajú sa kúpiť znova.',
	'kb.noRegistration': 'Registrácia nie je potrebná, vstupenky si môžete kúpiť aj bez vytvorenia účtu. Stačí zadať e-mail, na ktorý vám vstupenky prídu.',
	'kb.dicOptional': 'Pole DIČ nie je povinné, nákup sa dá dokončiť aj bez jeho vyplnenia.',
	'kb.noPrint': 'Vstupenku netreba tlačiť. Pri vstupe stačí ukázať PDF v mobile alebo si vstupenku uložiť do mobilnej peňaženky – vytlačiť si ju samozrejme môžete.',
	'kb.giftVoucher': 'Univerzálny darčekový poukaz na podujatia predávané cez Inviton zatiaľ nemáme. Niektorí organizátori však vlastný poukaz predávajú – napíšte mi prosím, o aké podujatie ide.',
	'kb.useTicket': 'Vstupenka prišla e-mailom ako PDF s QR kódom. Pri vstupe ju stačí ukázať v mobile alebo vytlačenú, kód sa naskenuje.',
	'kb.attendeeData': 'Údaje o účastníkoch podujatia vám nemôžeme poskytnúť, chráni ich GDPR. Ak ste účastníkom vy, rád skontrolujem vašu vlastnú objednávku.',

	'sit.avl.onSale': 'Asistent povedal, že vstupenky sú v predaji, zákazníkovi to nestačilo',
	'sit.avl.soldOut': 'Asistent povedal, že termín je vypredaný',
	'sit.avl.saleEnded': 'Asistent povedal, že predaj vstupeniek už skončil',
	'sit.avl.saleNotStarted': 'Asistent povedal, kedy sa predaj otvorí',
	'sit.avl.noOnlineSale': 'Event nemá vstupenky v online predaji',
	'sit.avl.eventEnded': 'Podujatie už prebehlo',
	'sit.avl.notFound': 'Event sa nepodarilo nájsť v systéme',
	'sit.ost.moneyLeft': 'Podľa systému platba neprešla, ale zákazníkovi odišli peniaze z účtu',
	'sit.ost.pendingTransfer': 'Objednávka čaká na bankový prevod',
	'sit.ost.nothingFound': 'Na overenú adresu nie je v systéme žiadna objednávka ani pokus o platbu',
	'sit.ost.manualCheck': 'Platba v stave PartiallyAuthorized – treba ju ručne overiť v platobnej bráne',
	'sit.ost.severalEvents': 'Zaplatené objednávky na viac podujatí, podujatie sa nepodarilo priradiť',
	'sit.ost.paidIssue': 'Objednávka je zaplatená, ale zákazníkovi niečo nesedí (napr. platba navyše)',
	'sit.kb.notEnough': 'Automatická odpoveď zákazníkovi nestačila',
	'validation.emailTypo': 'Skontrolujte prosím adresu – vyzerá, že je v nej preklep. Ak je správna, pošlite ju ešte raz.',
	'main.moreOptions': 'Ďalšie možnosti',
	'main.lessOptions': 'Menej možností',
	'flow.invoiceChange.short': 'faktúra',
	'flow.promoCode.short': 'zľavový kód',
	'flow.refund.short': 'storno',
	'ost.paidForEvent': 'Na adresu {orderEmail} vidím v systéme dokončenú a zaplatenú objednávku na podujatie {eventName}. Platba teda prešla a vstupenky boli odoslané na túto adresu.',
	'ost.paidAndFailedForEvent': 'Na adresu {orderEmail} vidím v systéme dokončenú objednávku na podujatie {eventName}, ale aj neúspešné pokusy o platbu. Za neúspešné pokusy by vám peniaze strhnuté byť nemali.',
	'ost.resendOfferForEvent': 'Chcete, aby som vám vstupenky na podujatie {eventName} poslal na {orderEmail} znova?',
	'evq.organizerAnswer': 'Inviton zabezpečuje predaj vstupeniek, na otázky k samotnému podujatiu vám preto najlepšie odpovie jeho organizátor: {organizerEmail}{organizerPhoneLine}',
	'evq.answerCapacity': 'Kapacitu podujatia a počet predaných vstupeniek nezverejňujeme. Ak to potrebujete vedieť, napíšte organizátorovi: {organizerEmail}{organizerPhoneLine}\n\nStránka podujatia: {eventUrl}',
	'oth.organizerFirst': 'Na otázky k podujatiu (miesto, sedenie, program, VIP, kapacita, pripojenie, záznam, kúpa na mieste) odpovie organizátor: {organizerEmail}{organizerPhoneLine}\n\nAk ide o vstupenku, platbu alebo faktúru, napíšte nám.',
	'oth.organizerFirstOk': 'Stačí, napíšem organizátorovi',
	'oth.organizerFirstSupport': 'Ide o vstupenku, platbu alebo faktúru – napísať podpore',
	'oth.organizerFirstDone': 'Dobre, organizátor vám odpovie najlepšie. Ak by ste ešte niečo potrebovali, som tu. 👋',
	'sit.evq.notEnough': 'Asistent dal kontakt na organizátora a odkaz na event, zákazníkovi to nestačilo',
	'evq.answerPrice': 'Ceny vstupeniek, vrátane zvýhodnených, nájdete na stránke podujatia: {eventUrl}\n\nAk tam odpoveď nie je, zľavy a ceny určuje organizátor – napíšte mu, prosím, na {organizerEmail}',
	'evq.answerDates': 'Na stránke podujatia sú všetky vypísané termíny: {eventUrl}\n\nIný termín alebo rezerváciu mimo nich vie dohodnúť len organizátor – napíšte mu, prosím, na {organizerEmail}',
	'evq.answerAge': 'Vekové obmedzenie a podmienky pre deti určuje organizátor podujatia – napíšte mu, prosím, na {organizerEmail}',
	'evq.answerOnsite': 'Či sa dajú vstupenky kúpiť aj na mieste, vie povedať len organizátor podujatia – napíšte mu, prosím, na {organizerEmail}\n\nOnline ich kúpite tu: {eventUrl}',
	'evq.answerHours': 'Otváracie hodiny a to, či sa dá prísť kedykoľvek, určuje organizátor podujatia – napíšte mu, prosím, na {organizerEmail}',
	'evq.answerRecording': 'Záznam alebo online prenos z podujatia zabezpečuje organizátor, Inviton k nemu prístup nemá – napíšte mu, prosím, na {organizerEmail}',
	'evq.answerCash': 'Vstupenky cez Inviton sa platia online v nákupnom košíku (karta, Google Pay / Apple Pay, prípadne bankový prevod). Či sa dá zaplatiť v hotovosti na mieste, vie len organizátor podujatia – napíšte mu, prosím, na {organizerEmail}\n\nOnline kúpite vstupenky tu: {eventUrl}',
	'evq.answerWho': 'Inviton zabezpečuje predaj vstupeniek. Pre koho je podujatie určené, čo si treba priniesť alebo ako prebieha, vie najlepšie organizátor – napíšte mu, prosím, na {organizerEmail}\n\nZákladné informácie sú na stránke podujatia: {eventUrl}',
};
